import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';

import { mapTagFields } from './helpers';

const VpMediaTagsList = ({ tags = [] }) => {
  const tagList = useMemo(() => mapTagFields(tags), [tags]);
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {tagList?.map((tag) => (
        <Chip label={tag?.name} key={tag?.id} />
      ))}
    </Stack>
  );
};

VpMediaTagsList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired
};

export default VpMediaTagsList;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTagsList.jsx